export { Head } from './StructuredData';
